var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSurveillance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M58.419,39.581c-1.536,0-2.785,1.249-2.785,2.784c0,1.536,1.249,2.785,2.785,2.785s2.785-1.249,2.785-2.785 C61.204,40.83,59.955,39.581,58.419,39.581z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.366,55.635c-1.104,0-2,0.896-2,2v2.554H54.781V52.7h12.023c1.104,0,2-0.896,2-2V34.02c0-1.104-0.896-2-2-2h-39.96 c-0.619,0-1.202,0.286-1.581,0.775c-0.379,0.489-0.51,1.125-0.355,1.725l0.518,2.007h-1.793c-1.104,0-2,0.896-2,2v7.678 c0,1.104,0.896,2,2,2h4.808l0.773,2.996c0.228,0.883,1.024,1.5,1.937,1.5h19.63v9.488c0,1.104,0.896,2,2,2h17.585v2.554 c0,1.104,0.896,2,2,2s2-0.896,2-2v-9.107C74.366,56.53,73.471,55.635,72.366,55.635z M27.408,44.205h-1.775v-3.678h0.826 l0.26,1.009L27.408,44.205z M30.654,40.773l-0.709-2.746c0-0.001-0.001-0.002-0.001-0.002l-0.518-2.005h35.378V48.7H32.701 L30.654,40.773z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurveillance);
export default __webpack_public_path__ + "static/media/surveillance.fe55c853d573dc95d0f32a085b9c03bf.svg";
export { ForwardRef as ReactComponent };